import { useContext, ref } from "@nuxtjs/composition-api";
const bannerProps = {
  linktext: {
    type: String,
    default: ""
  },
  linktype: {
    type: String,
    default: ""
  },
  link: {
    type: String,
    default: ""
  },
  linktarget: {
    type: String,
    default: "_self"
  },
  linkcolor: {
    type: String,
    default: ""
  },
  image: {
    type: String,
    default: ""
  },
  descriptioncolor: {
    type: String,
    default: ""
  },
  description: {
    type: String,
    default: ""
  },
  gradient: {
    type: String,
    default: ""
  }
};
function useCmsBanner(props) {
  const context = useContext();
  const magentoImage = ref(null);
  const getComponentClasses = () => {
    return {
      "dark-link": props.linkcolor === "dark",
      "light-link": props.linkcolor === "light",
      "dark-description": props.descriptioncolor === "dark",
      "light-description": props.descriptioncolor === "light"
    };
  };
  if (props.image) {
    const { magentoBaseUrl } = context.app.$vsf.$magento.config;
    magentoImage.value = magentoBaseUrl + "/media/" + props.image;
  }
  const isNewTab = props.linktarget === "_blank";
  const isExternal = isNewTab || props.link.startsWith("http");
  return {
    getComponentClasses,
    isNewTab,
    isExternal,
    magentoImage
  };
}
var useCmsBanner_default = useCmsBanner;
export {
  bannerProps,
  useCmsBanner_default as default,
  useCmsBanner
};
